module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.columns), function(column, key) {
    return _c('div', {
      key: key,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Column " + _vm._s(key))]), _vm._v(" "), _c('select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.updateColumn(key, $event)
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }), _vm._v(" "), _vm._l((_vm.options), function(option, optionKey) {
      return _c('option', {
        domProps: {
          "value": optionKey,
          "selected": column.label == option.label
        }
      }, [_vm._v(_vm._s(option.label))])
    })], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmed()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("GROUPS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b4d022c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/GroupsFormsColumns.vue
// module id = 1546
// module chunks = 1